import styled from '@emotion/styled';
import { Row } from 'antd';

export const OverridingRow = styled(Row)`
  margin: ${props => props.theme.spacing.xs} 0 ${props => props.theme.spacing.xxs} 0;
`;

export const OverridingLabel = styled.p`
  font-style: italic;
  margin-bottom: 0;
`;

export const SummaryValueText = styled.p`
  font-size: 32px;
  font-weight: ${props => props.theme.fontWeight.bold};
  margin-bottom: 0;
`;
